import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ClientId } from '../model/enum';
import { LoginModel } from '../model/login-model';
import { RegisterModel } from '../model/register-model';
import { ResetPasswordModel } from '../model/reset-password-model';
import { ForgotPasswordModel } from '../model/forgot-password-model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly url = environment.apiUrl;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  getClienteIdLocal(): string | null {
    if (!isPlatformBrowser(this.platformId)) return null;
    return localStorage.getItem('clientId');
  }

  setClienteIdLocal(clientId: string) {
    if (!isPlatformBrowser(this.platformId)) return;
    localStorage.setItem('clientId', clientId);
  }

  verificaClientId(clientId: string): ClientId | null {
    switch (clientId) {
      case 'ControLimit':
        return ClientId.ControLimit;
      case 'MetaFacil':
        return ClientId.MetaFacil;
      case 'CountDown':
        return ClientId.CountDown;
      case 'ProductControl':
        return ClientId.ProductControl;
      case 'TatuGestor':
        return ClientId.TatuGestor;
      case 'CartaoVirtual':
        return ClientId.CartaoVirtual;
      case 'JaAssistiu':
        return ClientId.JaAssistiu;
      default:
        return null;
    }
  }

  create(model: RegisterModel): Observable<RegisterModel> {
    return this.http.post<RegisterModel>(`${this.url}/register`, model);
  }

  login(model: LoginModel): Observable<{ redirectUrl: string }> {
    return this.http.post<{ redirectUrl: string }>(`${this.url}/login`, model, {
      withCredentials: true,
    });
  }

  forgotPassword(model: ForgotPasswordModel): Observable<any> {
    return this.http.post<any>(`${this.url}/forgot-password`, model);
  }

  resetPassword(model: ResetPasswordModel): Observable<any> {
    return this.http.post<any>(`${this.url}/reset-password`, model);
  }

  exchangeCodeForToken(code: string, state: string): Observable<any> {
    return this.http.get(
      `${this.url}/signin-google?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
      { withCredentials: true },
    );
  }

  getGoogleLoginUrl(returnUrl: string): string {
    return `${this.url}/signin-google/start?returnUrl=${encodeURIComponent(returnUrl)}`;
  }

  isTrustedRedirect(url: string): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    try {
      const target = new URL(url, window.location.origin);
      const isHttps = target.protocol === 'https:';
      const isLocalDevelopment =
        !environment.production &&
        ['http:', 'https:'].includes(target.protocol) &&
        ['localhost', '127.0.0.1'].includes(target.hostname);
      const isDevHubHost =
        target.hostname === 'devhubcentral.com.br' ||
        target.hostname.endsWith('.devhubcentral.com.br');
      return (isHttps && isDevHubHost) || isLocalDevelopment;
    } catch {
      return false;
    }
  }
  isLogado() {
    return this.http.get<any>(`${this.url}/isLogado`);
  }
}
